<template>
    <div class="maxContainer subscriptionPlan"> 
      <!-- <img src="../../../../static/fxView/images/platform.svg" alt="" class="platfromThumb"> -->
	  <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
	   <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        <div class="mainTitle text-center my-3" v-if="subPlanDetail != ''">
          <h3 class="mb-2">{{subPlanDetail[0].plan_name}}  {{ $t('Subscription') }}</h3>
          <p class="mb-4">{{ $t('SubMsz') }} </p>
		  
        </div> 
        <div class="row d-flex align-items-center justify-content-center" v-if="subPlanDetail != ''">
			<div class="col-10" v-for="list in subPlanDetail[0].details" v-if="subPlanDetail[0].details != ''">
				<div class="card">  
					<div class="card-body p-0 d-flex align-items-center justify-content-between"> 
						<div class="left d-flex align-items-center">
							<div class="packPrice">
								<h4 v-html="(parseInt(list.id) <= 8)? 'BASIC PACKAGE' : ((parseInt(list.id) == 10)? 'STANDARD PACKAGE' : 'PREMIUM PACKAGE')"> </h4>
								$ {{list.amount}} <span>{{ $t('mnth') }}</span>
								<div class="sml">
									{{$t('freeMin')}} {{subscriptionDeposit(list,'hh')}} {{$t('deposit')}}
								</div>
							</div> 
							<div class="featuresList p-3">
								<h4>{{$t('Features')}}:</h4>
								<!--<p v-if="subscriptionDeposit(list,'')">free</p>-->
								<ul>
									<li><img class="check" src="../../../../static/fxView/images/check.svg" alt="check">  {{$t('window')}} : {{JSON.parse(list.details).product_detail.os}}</li>
									<li><img class="check"  src="../../../../static/fxView/images/check.svg" alt="check"> {{$t('Memory')}}  : {{JSON.parse(list.details).product_detail.details.memory.charAt(0)}} GB</li> 
									<li><img class="check"  src="../../../../static/fxView/images/check.svg" alt="check"> {{$t('Cpu')}}: {{JSON.parse(list.details).product_detail.details.cpu}}</li> 
									<li><img class="check"  src="../../../../static/fxView/images/check.svg" alt="check"> {{$t('ssdDisk')}}  : {{JSON.parse(list.details).product_detail.details.disk}} GB</li> 
								</ul>
							</div>
						</div> 
						<div class="px-3" v-if="parseInt($route.query.id) == 6">
							<router-link :to="{name: 'fxView.createSubTicket' , query: {'plan_id':subPlanDetail[0].id,'plan_detail_id' : list.id}}" class="prism_btn btn_sm" title="subscribe" data-placement="top"  data-toggle="tooltip" v-if="parseInt(get_user.verified_status) == 1">
								 {{ $t('create') }}
							</router-link>
							<p class="badge-danger badge badge-pill" v-else>{{$t('notVerified')}}</p>
						</div>		
					</div>
				</div> 
			</div>
        </div> 
        <div class="text-center mb-5">
        	<router-link :to="{name: 'fxView.subscriptionTool'}" class="underline" title="back" >
				 {{ $t('backSubList') }}
			</router-link>
        </div>
    </div>
</template>
<script> 
	import { fxViewMixins } from '@/plugins/fxView'
	import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
	export default {
		name: 'Subscription-Tool',
		mixins: [fxViewMixins],
		data() {
			return {
				//===========prop in loader component=======
				col_span : 5,
				//============message and loader ===========
				response_msg : '',
				msg_type : '',
				pageLoader : false,
				loaderFuncRun : '1',
				//==========================================
				pageLimit : '15',
				search : '',
				page : '1'
			}
		},
		methods:{
			subscriptionDeposit(getDetail,getData){
				if(getData == ''){
					if(parseInt(this.get_user.profile.total_deposit) > 5000){
						if(parseInt(this.get_user.profile.total_deposit) >= 5000 && parseInt(this.get_user.profile.total_deposit) < 20000 && parseInt(getDetail.id) == 8){
							return true;
						}else if(parseInt(this.get_user.profile.total_deposit) >= 20000  && parseInt(this.get_user.profile.total_deposit) < 50000 && parseInt(getDetail.id) == 10){
							return true;
						}else if(parseInt(this.get_user.profile.total_deposit) >= 50000 && parseInt(getDetail.id) == 11){
							return true;
						}
					}else{
						return false;
					}
				}else{
					if(parseInt(getDetail.id) == 8){
						return '$5,000';
					}else if(parseInt(getDetail.id) == 10){
						return '$20,000';
					}else if(parseInt(getDetail.id) == 11){
						return '$50,000';
					}
				}
			},
			
			detail(){
                let input_json={
                    'globalParams' :{
                        'plan_id' : this.$route.query.id
                    },
                    'localParams' :{ "parameter" : this , 'page' : 'service_plan'}
                }
                this._runGetSubPlanDetail(input_json)
            },
			unsubscribe1(getId){
				let input_json={
                    'globalParams' :{
                        'subscription_id' : getId
                    },
                    'localParams' :{ "parameter" : this }
                }
                this._runUnsubService(input_json)
			}
		},
		created(){
			this.detail()
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/subscription_service_plan.vue